import React, { useState, useEffect, useCallback } from 'react';
import { Spinner, Grid, Cell, FABButton, Button, Icon } from 'react-mdl';
import axios from 'axios';
import moment from 'moment';

import DescriptionItem from '../../components/DescriptionItem';
import { BOOKING_TYPE_AIRPORT_TRANSFER, BOOKING_TYPE_RETURN_TRANSFER, BOOKING_TYPE_DEPARTURE_TRANSFER, BOOKING_TYPE_CHAUFFEUR_SERVICES, BOOKING_TYPE_CAR_RENTALS } from '../../const'


const DetailPage = (props) => {
    const {bId , vipType} = props.match.params;
    const [book, setBook] = useState()
    const [airPortPickup, setAirPortPickup] = useState()
    const [airPortDropoff, setAirPortDropoff] = useState()
    const [trainPickup, setTrainPickup] = useState()
    const [trainDropoff, setTrainDropOff] = useState()
    useEffect(() => {
        async function fetchBookInfo() {
            const { bId } = props.match.params
            const result = await axios(
                process.env.REACT_APP_API_URL + "/api/v1/partners/" + bId
            );
            setBook(result.data.data)
            console.log(result);
        }
        if (props.location.state && props.location.state.book) {
            setBook(props.location.state.book)
        } else {
            fetchBookInfo();
        }
    }, [setBook, props.location, props.match])
    useEffect(() => {
        const mapKeys = {
            pickUpSign: "Pickup sign",
            flightNumber: "Flight number",
            flightType: "Flight Type",
            tailNumber: "Tail number",
            fbo: "FBO",
            trainNumber: "Train number"
        }
        if (book) {

            if (book.airportPickUpInfo) {
                const tmp = Object.keys(book.airportPickUpInfo).map(key => {
                    return {
                        key: mapKeys[key],
                        value: book.airportPickUpInfo[key]
                    }
                })
                setAirPortPickup(tmp)
            }
            if (book.trainPickUpInfo) {
                const tmp = Object.keys(book.trainPickUpInfo).map(key => {
                    return {
                        key: mapKeys[key],
                        value: book.trainPickUpInfo[key]
                    }
                })
                setTrainPickup(tmp)
            }
            if (book.airportDropOffInfo) {
                const tmp = Object.keys(book.airportDropOffInfo).map(key => {
                    return {
                        key: mapKeys[key],
                        value: book.airportDropOffInfo[key]
                    }
                })
                setAirPortDropoff(tmp)
            }
            if (book.trainDropOffInfo) {
                const tmp = Object.keys(book.trainDropOffInfo).map(key => {
                    return {
                        key: mapKeys[key],
                        value: book.trainDropOffInfo[key]
                    }
                })
                setTrainDropOff(tmp)
            }
        }
    }, [book])

    const goBack = useCallback(() => {
        props.history.goBack();
    }, [props.history])

    if (!book) {
        return (
            <div className="page-container landing-grid-details flex-vertical justify-center text-center align-center">
                <Cell col={12}>
                    <Spinner singleColor />
                </Cell>
            </div>)
    }
    if ((book.status === "cancelled_by_agent") || (book.status === "cancellation_accepted_by_agent") || (book.status === "cancellation_requested_by_client")) {
        return (
            <div className="cancelledBookingDiv">
                <img src="/images/icons/coution.png" alt="icon coution" />
                <p >The booking was cancelled</p>
            </div>
        )
    }
    return (
        <div className="landing-grid-details book-detail flex-vertical justify-between">
            <Cell col={12} className='mb-0'>
                <div className="tracker-area flex justify-between align-baseline pb-0">
                    <Button className="btn-back" onClick={goBack}>
                        <Icon name="keyboard_backspace" />
                    </Button>
                    <p className="color-grey">#{book.number}</p>
                </div>

                <h4>Booking details</h4>

                {<DescriptionItem
                    title={`${book.type === BOOKING_TYPE_CAR_RENTALS ? "Delivery date and time" : "Date and time"}`}
                    description={moment.utc(vipType === 'departure' ? book?.meetAndAssist?.departure?.pickUpDate : book.pickUpDate).format("dddd Do MMMM, LT")} />}

                {<DescriptionItem
                    title={`${book.type === BOOKING_TYPE_CAR_RENTALS ? "Delivery location" : "Pick-up location"}`}
                    description={vipType === 'departure' ? book.dropOffLocation.fullAddress : book.pickUpLocation.fullAddress} />}

                {/* {book.type !== BOOKING_TYPE_AIRPORT_TRANSFER && book.duration && (<DescriptionItem
                    title="Duration"
                    description={`${book.duration} ${book.durationType === 'hourly' ? 'hours' : 'days'}`}
                />)} */}
                {((book.type !== BOOKING_TYPE_AIRPORT_TRANSFER) && (book.type !== BOOKING_TYPE_RETURN_TRANSFER) && (book.type !== BOOKING_TYPE_DEPARTURE_TRANSFER))
                    && book.duration && book.durationType === 'hourly' ? (<DescriptionItem
                        title="Duration"
                        description={`${book.duration} hours`}
                    />) : (
                    <>
                        {book.durationType === "daily" && (
                            <div className="row ml-0">
                                <DescriptionItem
                                    title="Duration"
                                    description={`${book.duration.length} ${book.duration.length > 1 ? 'days' : 'day'}`}
                                    className="col-6"
                                />
                                <div>
                                    {book.duration.map((value, index) => {
                                        return (
                                            <DescriptionItem
                                                title={`day ${index + 1}`}
                                                description={`${value} hours`}
                                            // className="col-6"
                                            />
                                        )
                                    })}
                                </div>
                            </div>)}
                    </>
                )}

                {book.type === BOOKING_TYPE_CAR_RENTALS && <DescriptionItem
                    title="Drop off date and time"
                    description={moment.utc(book.dropOffDate).format("dddd Do MMMM, LT")}
                />}
                {(book.type === BOOKING_TYPE_AIRPORT_TRANSFER || book.type === BOOKING_TYPE_DEPARTURE_TRANSFER || book.type === BOOKING_TYPE_RETURN_TRANSFER || book.type === BOOKING_TYPE_CAR_RENTALS) && !vipType && <DescriptionItem
                    title="Drop off location"
                    description={book.dropOffLocation.fullAddress} />}

                {book.type === BOOKING_TYPE_CAR_RENTALS && <DescriptionItem
                    title="Duration"
                    description={`${moment(book.dropOffDate).diff(moment(book.pickUpDate), "days") + 1} days`}
                />}

                {/* Airport Pickup Info */}
                {airPortPickup && vipType !== 'departure' && <DescriptionItem
                    title={`Flight Information ${!vipType ? '(Pickup)' : ''}`}
                    mapValues={airPortPickup}
                ></DescriptionItem>}

                {/* Train Pickup Info */}
                {trainPickup &&  vipType !== 'departure' &&  <DescriptionItem
                    title={`Train Information ${!vipType ? '(Pickup)' : ''}`}
                    mapValues={trainPickup}
                ></DescriptionItem>}

                {/* Airport DropOff Info */}
                {airPortDropoff &&  vipType !== 'arrival' && <DescriptionItem
                    title={`Flight Information ${!vipType ? '(Dropoff)' : ''}`}
                    mapValues={airPortDropoff}
                ></DescriptionItem>}

                {/* Train DropOff Info */}
                {trainDropoff &&  vipType !== 'arrival' && <DescriptionItem
                    title={`Train Information ${!vipType ? '(Dropoff)' : ''}`}
                    mapValues={trainDropoff}
                ></DescriptionItem>}

                {(book.type === BOOKING_TYPE_AIRPORT_TRANSFER || book.type === BOOKING_TYPE_DEPARTURE_TRANSFER || book.type === BOOKING_TYPE_RETURN_TRANSFER || book.type === BOOKING_TYPE_CHAUFFEUR_SERVICES) && <DescriptionItem
                    title="Lead passenger"
                    description={`${book.passengerInfo.title} ${book.passengerInfo.lastName}`} />}

                {(book.type === BOOKING_TYPE_AIRPORT_TRANSFER || book.type === BOOKING_TYPE_DEPARTURE_TRANSFER || book.type === BOOKING_TYPE_RETURN_TRANSFER || book.type === BOOKING_TYPE_CHAUFFEUR_SERVICES) && <DescriptionItem
                    title="Number of passenger"
                    description={book.passengerInfo.passenger} />}

                {(book.type === BOOKING_TYPE_AIRPORT_TRANSFER || book.type === BOOKING_TYPE_DEPARTURE_TRANSFER || book.type === BOOKING_TYPE_RETURN_TRANSFER || book.type === BOOKING_TYPE_CHAUFFEUR_SERVICES) && <DescriptionItem
                    title="Number of luggage"
                    description={book.passengerInfo.luggage} />}

                {(book.type === BOOKING_TYPE_CAR_RENTALS) &&
                    <div className="driver-info--panel">
                        <div className="drvier--title">Authorized driver(s)</div>
                        {book.driversInfo && book.driversInfo.length > 0 && book.driversInfo.map((driver, idx) =>
                            <DescriptionItem
                                key={idx}
                                title={`Driver${idx + 1}`}
                                // description={driver.fullName} 
                                description={`${driver.title} ${driver.lastName}`}
                            />
                        )}
                    </div>}

                {book && book.passengerInfo && book.passengerInfo.phone && <DescriptionItem
                    title="Contact number"
                    description={book.passengerInfo.phone} />}

            </Cell>
            <Cell col={12} style={{marginTop:"40px"}} className="text-center mx-0 mb-0 w-100" >
                {/* <a href={`tel:${book && book.bookingOperations ? book.bookingOperations[0].contactNo : ''}`} className="phone-container">
                    <FABButton style={{ background: "#A79779" }}>
                        <img src="/images/icon_phone.png" alt="icon phone" />
                    </FABButton>
                </a> */}
                <div className='d-flex flex-column justify-content-center'>

                    <a
                        className={`call-btn mb-4`}
                        href={`tel:${book && book.passengerInfo ? book.passengerInfo.phone : ''}`}
                    >
                        Call {book && book.passengerInfo ? `${book.passengerInfo.title} ${book.passengerInfo.lastName}` : ''}
                    </a>
                    <a
                        className={`call-btn`}
                        href={`tel:${book && book.bookingOperations && book.bookingOperations.length > 0 ? book.bookingOperations[0].contactNo : ''}`}
                    >
                        Call ROLZO
                    </a>
                </div>
            </Cell>
        </div>
    );
}

export default DetailPage;
